import EmblaCarousel from "embla-carousel"
import AutoScroll from "embla-carousel-auto-scroll"

export default class Marquee {
  constructor() {
    this.marquees = document.querySelectorAll(".image-marquee__carousel")
    this.initCarousels()
  }

  initCarousels() {
    this.marquees.forEach((node) => {
      const viewportNode = node.querySelector(".embla__viewport")
      const autoToggle = node.parentNode.querySelector(".play-pause")
      const autoToggleIcon = autoToggle ? autoToggle.querySelector(".play-pause__icon") : null
      const autoToggleText = autoToggle ? autoToggle.querySelector(".play-pause__text") : null

      if (viewportNode) {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")

        const emblaApi = EmblaCarousel(
          viewportNode,
          {
            loop: true,
            direction: node.classList.contains("image-marquee__carousel--bottom") ? "rtl" : "ltr",
          },
          [AutoScroll({ playOnInit: !mediaQuery.matches, speed: 1 })],
        )

        console.log(autoToggle, autoToggleIcon, autoToggleText)

        if (!mediaQuery.matches) {
          autoToggleIcon.classList.remove("play-pause__icon--play")
          autoToggleText.textContent = "Image Auto Scroll Off"
        }

        autoToggle.addEventListener("click", () => {
          if (emblaApi.plugins().autoScroll.options.playOnInit) {
            emblaApi.plugins().autoScroll.stop()
            emblaApi.plugins().autoScroll.options.playOnInit = false
            autoToggleIcon.classList.remove("play-pause__icon--pause")
            autoToggleIcon.classList.add("play-pause__icon--play")
            autoToggleText.textContent = "Image Auto Scroll On"
          } else {
            emblaApi.plugins().autoScroll.play()
            emblaApi.plugins().autoScroll.options.playOnInit = true
            autoToggleIcon.classList.remove("play-pause__icon--play")
            autoToggleIcon.classList.add("play-pause__icon--pause")
            autoToggleText.textContent = "Image Auto Scroll Off"
          }
        })
      }
    })
  }
}
